import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WHATSAPP_NUMBER = "7388047001";

// Axios instance that sends cookies for auth
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// ---- Leads ----
export const submitLead = async (payload) => (await api.post("/leads", payload)).data;

// ---- Auth ----
export const exchangeSession = async (session_id) =>
  (await api.post("/auth/session", { session_id })).data;

export const fetchMe = async () => (await api.get("/auth/me")).data;

export const logout = async () => (await api.post("/auth/logout")).data;

export const registerEmail = async (payload) =>
  (await api.post("/auth/register", payload)).data;

export const loginEmail = async (payload) =>
  (await api.post("/auth/login", payload)).data;

export const forgotPassword = async (email) =>
  (await api.post("/auth/forgot-password", { email })).data;

export const resetPassword = async (token, password) =>
  (await api.post("/auth/reset-password", { token, password })).data;

export const startGoogleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirect = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
};

// ---- Customer ----
export const fetchMyLeads = async () => (await api.get("/me/leads")).data;

// ---- Admin ----
export const fetchLeads = async () => (await api.get("/admin/leads")).data;
export const updateLeadStatus = async (id, status) =>
  (await api.patch(`/admin/leads/${id}`, { status })).data;
export const updateLeadStage = async (id, stage) =>
  (await api.patch(`/admin/leads/${id}/stage`, { stage })).data;
export const deleteLead = async (id) => (await api.delete(`/admin/leads/${id}`)).data;

// ---- Blog (public) ----
export const fetchBlogPosts = async () => (await api.get("/blog")).data;
export const fetchBlogPost = async (slug) => (await api.get(`/blog/${slug}`)).data;

// ---- Blog (admin) ----
export const fetchAdminBlogPosts = async () => (await api.get("/admin/blog")).data;
export const createBlogPost = async (payload) =>
  (await api.post("/admin/blog", payload)).data;
export const updateBlogPost = async (id, payload) =>
  (await api.patch(`/admin/blog/${id}`, payload)).data;
export const deleteBlogPost = async (id) => (await api.delete(`/admin/blog/${id}`)).data;
